module.exports = __webpack_public_path__ + "img/soc.9c78acbc.jpg";